import HttpClienteToken from '../../services/HttpClientToken';

import { EstadoProps } from '../../interfaces/catalogos/EstadoInterface';

export const Estados = () => {

    return new Promise<EstadoProps[]>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.get('/Api/Estado/', token)
            .then( ({ data } : { data : EstadoProps[] } ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( [] );
            });
        }

    });

}

export const ObtenerEstados = () => {

    return new Promise<EstadoProps[]>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.get('/Api/Estado/ObtenerEstados/', token)
            .then( ({ data } : { data : EstadoProps[] } ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( [] );
            });
        }

    });

}

export const ActualizarEstado = ( params: EstadoProps ) => {

    return new Promise<EstadoProps>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/Estado/Actualizar', params, token)
            .then( ({ data } : { data : EstadoProps} ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( {
                    idEstado: 0,
                    clave: '',
                    descripcion: '',
                    activo: false,
                    idPais: 0,                    
                });
            });
        }

    });

}

export const AgregarEstado = ( params: EstadoProps ) => {

    return new Promise<EstadoProps>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/Estado/Agregar', params, token)
            .then( ({ data } : { data : EstadoProps} ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( {
                    idEstado: 0,
                    clave: '',
                    descripcion: '',
                    activo: false,
                    idPais: 0,                
                });
            });
        }
    });
}